import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CategoryHero from './components/CategoryHero';
import ArticleGrid from './components/ArticleGrid';
import FeaturedArticle from './components/FeaturedArticle';

export default function Category() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <CategoryHero />
        <FeaturedArticle />
        <ArticleGrid />
      </main>
      <Footer />
    </div>
  );
}